export default __webpack_public_path__ + "static/media/placeholder_dummy2016-pragentur01-de-mobile.c2bf6a78.png";